<script>
import { sanitizeUrl } from '@braintree/sanitize-url';
import { assetURL, baseURL } from '../../utils/url';

export default {
    props: {
        title: {
            default() {
                return '';
            },
        },
        banner: {
            default() {
                return '';
            },
        },
    },
    data() {
        return {
            banner: `${assetURL}images/location-banner.png`,
            estates: [],
            properties: [],
        };
    },
    methods: {
        sanitize(url) {
            return sanitizeUrl(url);
        },
        getEstatesInLocation(slug) {
            axios.get(`/locations/getEstates/${slug}`).then((response) => {
                this.estates = response.data.estates;
                this.scrollTo();
            });
        },
        scrollTo() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            if (
                !['estatesInLocation', 'propertiesInLocation'].includes(
                    urlParams.get('scroll')
                )
            ) {
                return;
            }
            const element = document.getElementById(urlParams.get('scroll'));
            if (element == null) {
                return;
            }
            element.scrollIntoView();
        },
    },
    mounted() {
        let slug = new URL(location.href).pathname.match(/[^\/]+/g);
        slug = slug[slug.length - 1];
        this.getEstatesInLocation(slug);
    },
};
</script>
<template>
    <div
        class="tw-flex tw-flex-row tw-h-auto location-estate__section"
        id="estatesInLocation"
    >
        <div
            class="container tw-pl-4 lg:tw-pl-24 xxl:tw-pl-28 -tw-mr-4 lg:-tw-mr-24 xxl:-tw-mr-28 tw-z-[1]"
        >
            <h2
                class="tw-text-darkGreen tw-leading-10 tw-text-[40px] md:tw-text-3xl lg: xl:tw-text-5xl tw-font-extrabold tw-text-center tw-mb-12"
            >
                {{ this.$props.title }}
            </h2>
            <div
                class="tw-flex tw-flex-col tw-h-auto tw-space-y-7 location-estate__grid"
            >
                <div
                    :class="'tw-h-[352px] md:tw-h-[240px] tw-w-[340px] md:tw-w-full tw-flex tw-flex-col md:tw-flex-row location-estate__wrapper'"
                    v-for="(estate, index) in estates"
                >
                    <div
                        class="tw-w-full tw-h-[160px] md:tw-h-full location-estate__image"
                    >
                        <img
                            :src="estate.thumbnail_image"
                            class="tw-w-full tw-h-full tw-object-cover tw-object-center"
                        />
                    </div>
                    <div
                        class="tw-w-full tw-h-[192px] md:tw-h-auto tw-bg-grey1 tw-p-3 md:tw-p-4 xxl:tw-p-8 tw-relative tw-overflow-hidden location-estate__content"
                    >
                        <h3
                            class="tw-text-darkGreen tw-text-[20px] xxl:tw-text-[24px] tw-font-bold md:tw-font-extrabold tw-tracking-wide"
                        >
                            {{ estate.name }}
                        </h3>
                        <p
                            class="tw-text-darkTeal tw-text-[16px] tw-font-medium tw-block md:tw-hidden lg:tw-block tw-overflow-hidden tw-h-[125px]"
                        >
                            {{ estate.loc_description }}
                        </p>
                        <!-- text for tablet -->
                        <p
                            class="tw-text-darkTeal tw-text-[16px] tw-font-medium tw-hidden md:tw-block lg:tw-hidden"
                        >
                            {{
                                estate.long_description.substring(0, 50) + '...'
                            }}
                        </p>
                        <a
                            class="tw-absolute tw-bottom-[5px] tw-right-[20px] tw-text-[inherit] hover:tw-text-[inherit] tw-no-underline"
                            :href="this.sanitize(estate.url)"
                        >
                            <p
                                class="tw-uppercase tw-tracking-wide tw-text-[12px] xxl:tw-text-[14px]"
                            >
                                Learn more >
                            </p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="tw-w-1/2 tw-hidden md:tw-block">
            <div
                class="tw-text-darkGreen tw-leading-10 tw-text-[40px] md:tw-text-3xl lg: xl:tw-text-5xl tw-font-extrabold tw-text-center tw-mb-10"
            >
                {{ this.$props.title }}
            </div>
            <img class="tw-h-[240px] tw-w-full" :src="this.$props.banner" />
        </div> -->
    </div>
</template>

<style lang="scss">
.location-estate__grid {
    align-items: center;
    max-width: calc(546px * 2);
    margin: 0 auto;
}
@media (min-width: 768px) {
    .location-estate__section {
        margin-top: 100px !important;
        margin-bottom: 160px !important;
    }
    .location-estate__grid {
        .location-estate__wrapper:not(:first-child) {
            margin-top: 48px;
        }
        .location-estate__wrapper:nth-child(even) {
            .location-estate__image {
                order: 2;
            }
            .location-estate__content {
                order: 1;
            }
        }
    }
    .location-estate__content,
    .location-estate__image {
        width: 50%;
        max-width: 546px;
    }
}
</style>
